<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12 16.4l-6-6L7.4 9l4.6 4.6L16.6 9l1.4 1.4-6 6z"/></svg>